/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationForFinopsUnderUtilizedAwsEC2ComputeOptimizerResource extends models.RecommendationBaseForFinopsResource {
    constructor() {
        super();
        this.setDiscriminator("RecommendationForFinopsUnderUtilizedAwsEC2ComputeOptimizerResource");
    }

    getFixupPrototypeFunction() { return RecommendationForFinopsUnderUtilizedAwsEC2ComputeOptimizerResource.fixupPrototype; }

    static newInstance(model: Partial<RecommendationForFinopsUnderUtilizedAwsEC2ComputeOptimizerResource>): RecommendationForFinopsUnderUtilizedAwsEC2ComputeOptimizerResource {
        let obj = Object.assign(new RecommendationForFinopsUnderUtilizedAwsEC2ComputeOptimizerResource(), model);
        RecommendationForFinopsUnderUtilizedAwsEC2ComputeOptimizerResource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationForFinopsUnderUtilizedAwsEC2ComputeOptimizerResource>): RecommendationForFinopsUnderUtilizedAwsEC2ComputeOptimizerResource {
        if (!model) return null;
        return RecommendationForFinopsUnderUtilizedAwsEC2ComputeOptimizerResource.newInstance(<RecommendationForFinopsUnderUtilizedAwsEC2ComputeOptimizerResource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationForFinopsUnderUtilizedAwsEC2ComputeOptimizerResource) {
        if (!obj) return;

        models.RecommendationForFinopsUnderUtilizedAwsEC2ComputeOptimizerResource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationForFinopsUnderUtilizedAwsEC2ComputeOptimizerResource): boolean {
        if (models.RecommendationBaseForFinopsResource.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationForFinopsUnderUtilizedAwsEC2ComputeOptimizerResource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
